/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lifeScenario/gross_income': {
    width: 10,
    height: 18,
    viewBox: '0 0 10 18',
    data: '<path pid="0" d="M5.3 7.9c-2.27-.59-3-1.2-3-2.15C2.3 4.66 3.31 3.9 5 3.9c1.42 0 2.13.54 2.39 1.4.12.4.45.7.87.7h.3c.66 0 1.13-.65.9-1.27-.42-1.18-1.4-2.16-2.96-2.54V1.5C6.5.67 5.83 0 5 0S3.5.67 3.5 1.5v.66C1.56 2.58 0 3.84 0 5.77 0 8.08 1.91 9.23 4.7 9.9c2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-1.65 0-2.5-.59-2.83-1.43-.15-.39-.49-.67-.9-.67H.99c-.67 0-1.14.68-.89 1.3.57 1.39 1.9 2.21 3.4 2.53v.67c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-.65c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z" _fill="#2CB6F8" fill-rule="evenodd"/>'
  }
})
